import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Iuser } from "@api/types";

import getReducersLayout from "../utils/getReducersLayout";

// Actual Initial State
export const initialUserState: Iuser = {
  id: "",
  uid: "",
  username: "",
  wallet_address: "",
  balance: 0,
  expirience: 0,
  level: 0,
  avatar_url: "",
  avatar_generated: false,
  is_staff: false,
  referral_code: "",
  statistics: {
    id: "",
    total: {
      total: 0,
      games_won: 0,
      games_lose: 0,
      games_draw: 0,
      profits: 0,
      wagered: 0,
      max_profit: 0,
    },
    coinflip: {
      total: 0,
      games_won: 0,
      games_lose: 0,
      games_draw: 0,
      profits: 0,
      wagered: 0,
      max_profit: 0,
    },
    blackjack: {
      total: 0,
      games_won: 0,
      games_lose: 0,
      games_draw: 0,
      profits: 0,
      wagered: 0,
      max_profit: 0,
    },
    jackpot: {
      total: 0,
      games_won: 0,
      games_lose: 0,
      games_draw: 0,
      profits: 0,
      wagered: 0,
      max_profit: 0,
    },
  },
};

const userSlice = createSlice({
  initialState: initialUserState,
  name: "userData",
  reducers: {
    ...getReducersLayout<Iuser>(initialUserState),

    getUserStart: (state) => ({ ...state, loading: true }),
    updateBalance: (
      state,
      {
        payload: { balance, type },
      }: PayloadAction<{ balance: number; type: "add" | "substract" }>
    ) => {
      type === "add" ? (state.balance += balance) : (state.balance -= balance);
    },
    changeBalance: (state, { payload }: PayloadAction<{ balance: number }>) => {
      state.balance = payload.balance;
    },
    // getUserSuccess: (state, action) => ({
    //   ...state,
    //   loading: false,
    //   users: action.payload.users.map((u) => ({
    //     id: u.id,
    //     name: u.name,
    //     username: u.username,
    //   })),
    // }),
  },
});

export const { setData, resetData, updateBalance, changeBalance } =
  userSlice.actions;
export default userSlice;
